import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { IRiskAssessmentEditItem, RiskAssessmentEditItem } from "./riskAssessmentEditItem";

export interface IRiskAssessmentEditItems extends ListItems<IRiskAssessmentEditItem> {
}

export class RiskAssessmentEditItems extends ListItems<RiskAssessmentEditItem> implements IRiskAssessmentEditItems {
    constructor();
    constructor(obj: IRiskAssessmentEditItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, RiskAssessmentEditItem);
    }
}